import {defineComponent} from "vue";
import {mapActions, mapGetters} from "vuex";
import gql from "graphql-tag";
import {Controller} from "@/store/modules/hcs/controller/model";
import {DataProfile} from "@/store/modules/hcs/dataProfile/model";
import {ServiceProfile} from "@/store/modules/hcs/serviceProfile/model";
import {ContractProfileTemplate} from "@/store/modules/hcs/contractProfileTemplate/model";
import {DataComponentModel, ServiceComponentModel} from "@/store/modules/hds/Model";

interface LoadDataProps {
  loadControllers?: boolean;
  loadDataProfiles?: boolean;
  loadServiceProfiles?: boolean;
  loadContractProfileTemplates?: boolean;
}

interface LoadDataResult {
  controllers: Controller[];
  dataProfiles: DataProfile[];
  serviceProfiles: ServiceProfile[];
  contractProfileTemplates: ContractProfileTemplate[];
  dataComponentModels: DataComponentModel[];
  serviceComponentModels: ServiceComponentModel[];
}

export default defineComponent({
  computed: {
    ...mapGetters({
      hdsEntities: 'hds/entities',
    }),
  },
  methods: {
    ...mapActions({
      loadControllers: 'hcs/controller/findList',
      loadDataProfiles: 'hcs/dataProfile/findList',
      loadServiceProfiles: 'hcs/serviceProfile/findList',
      loadContractProfileTemplates: 'hcs/contractProfileTemplate/findList',
      gqlQuery: 'hds/gqlQuery'
    }),
    async loadData(props?: LoadDataProps) {
      const {
        loadControllers = true,
        loadDataProfiles = true,
        loadServiceProfiles = true,
        loadContractProfileTemplates = true,
      } = props ?? {};
      const result: LoadDataResult = {
        controllers: [],
        dataProfiles: [],
        serviceProfiles: [],
        contractProfileTemplates: [],
        dataComponentModels: [],
        serviceComponentModels: [],
      };

      if(loadControllers) {
        result.controllers = await this.loadControllers();
      }
      if(loadDataProfiles) {
        result.dataProfiles = await this.loadDataProfiles();
      }
      if(loadServiceProfiles) {
        result.serviceProfiles = await this.loadServiceProfiles();
      }
      if(loadContractProfileTemplates) {
        result.contractProfileTemplates = await this.loadContractProfileTemplates();
      }

      if(loadDataProfiles || loadServiceProfiles) {
        const dataComponentModelIds = result.dataProfiles
          .flatMap(dp => ([
            dp.dataComponentModelId,
            dp.dataImplementation?.dataComponentModelId
          ]))
          .filter(id => id !== undefined);

        const serviceComponentModelIds = result.serviceProfiles
          .flatMap(sp => ([
            sp.serviceComponentModelId,
            sp.serviceImplementation?.serviceComponentModelId
          ]))
          .filter(id => id !== undefined);

        const {dataComponentModels, serviceComponentModels} = await this.gqlQuery({
          query: gql`
            query FindDataComponentModels(
              $dataComponentModelIds: [ID!]!,
              $serviceComponentModelIds: [ID!]!
            ) {
              dataComponentModels: dataComponentModelInBulk(dataComponentModelIds: $dataComponentModelIds) {
                id
                name
                description
                dictionary {
                  id
                  name
                }
              }
              serviceComponentModels: serviceComponentModelInBulk(serviceComponentModelIds: $serviceComponentModelIds) {
                id
                name
                description
                dictionary {
                  id
                  name
                }
              }
            }`,
          variables: {
            dataComponentModelIds,
            serviceComponentModelIds
          },
        });

        result.dataComponentModels = dataComponentModels;
        result.serviceComponentModels = serviceComponentModels;
      }

      return result;
    }
  },
});
